import {
  INITIALIZATION,
  ADDRESS_PRODUCT_TYPE,
  MALFUNCTION,
  CALENDAR,
  ACCOUNT,
  PAYMENT,
  RE_ASSURANCE,
  PRODUCT_TYPE,
  machineConfiguration,
  CONFIRMATION,
} from "components/HomeRepairFunnelV2/state-machine/configuration";

import { RepairFunnelContext } from "components/HomeRepairFunnelV2/state-machine/configuration";
import { Product } from "types/product";

import { State } from "xstate";

interface Meta {
  name: string;
  slug: string;
  progress: number;
  position: number;
}

export const getCurrentMeta = (state: State<RepairFunnelContext>): Meta => {
  switch (true) {
    case state.matches(INITIALIZATION):
    case state.matches(ADDRESS_PRODUCT_TYPE):
      return machineConfiguration.states[ADDRESS_PRODUCT_TYPE].meta;
    case state.matches(MALFUNCTION):
    case state.matches(PRODUCT_TYPE):
    case state.matches(RE_ASSURANCE):
      return machineConfiguration.states[MALFUNCTION].meta;
    case state.matches(CALENDAR):
      return machineConfiguration.states[CALENDAR].meta;
    case state.matches(ACCOUNT):
      return machineConfiguration.states[ACCOUNT].meta;
    case state.matches(PAYMENT):
    case state.matches(CONFIRMATION):
      return machineConfiguration.states[PAYMENT].meta;
  }
};

export const getProductType = (product) => {
  return product.product_type === "Réfrigérateur & congélateur" ? "Réfrigérateur" : product.product_type;
};

export const getPackageTotal = (products: Product[]): number => {
  return products.reduce((totalPrice, item) => totalPrice + item.package_price, 0);
};

export const getAmount = (state: State<RepairFunnelContext>) => {
  const { products, discount } = state.context;

  const basePrice = getPackageTotal(products) / 100;

  if (!discount || Object.keys(discount).length === 0) {
    return basePrice;
  }
  if (discount.discount_type === "percentage") {
    return basePrice - basePrice * (discount.amount / 100);
  }
  if (basePrice - discount.amount / 100 < 0) {
    return 0;
  }
  return basePrice - discount.amount / 100;
};

export const MURFY_HOMEPAGE_URL = "https://murfy.fr";
